import {
  Box,
  Breadcrumbs,
  Button,
  CardContent,
  Container,
  Grid,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Logout } from '../auth/Logout'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { ListTimesheets } from '../projects/timesheets/ListTimesheets'
import { StyledCard } from '../../components/StyledCard'
import { useGetUserAccount } from '../userManagement/hooks'
import { useGetTimeSheets, useMutateUpdateTimeSheetForWorker } from './hooks'
import { Fetching } from '../../components/Fetching'
import { Edit as EditIcon } from '@mui/icons-material'
import { Delete as DeleteIcon } from '@mui/icons-material'

export const User = () => {
  const { id } = useParams()
  const { data: user, isFetching } = useGetUserAccount('user', id)
  const navigate = useNavigate()
  const [selectedTab, setSelectedTab] = useState('Timesheets')
  const [isExport, setIsExport] = useState(false);
  const ts = Date.now()
  const customToolBarConfig = {
    add: false,
    export: true,
    upload: false,
  }
  if (isFetching) {
    return <Fetching />
  }

  return (
    <>
      {user ? (
        <Box sx={{ marginTop: 1, marginLeft: 2, marginRight: 2 }}>
          <Container maxWidth='lg'>
            <Breadcrumbs aria-label='breadcrumb'>
              <Link to='/dashboard'> Home </Link>
              <Link to='/user-management'> Users Management </Link>
              <Typography component={'span'} color='text.primary' gutterBottom>
                {user.firstName} {user.lastName}
              </Typography>
            </Breadcrumbs>
            <Grid container spacing={2} sx={{ mt: 3 }}>
              <Grid item xs={12} sm={10} md={8} lg={5}>
                <StyledCard>
                  <CardContent>
                    <Grid container
                      sx={{
                        marginBottom: 2,
                      }}>
                      <Grid item md={6} width={'100%'} sx={{ marginBottom: { xs: 2, md: 0 } }}>
                        <Box sx={{ mr: { md: 2 }, height: '140px' }}>
                          <img
                            src={user.idPhoto || user.picture}
                            alt={user.firstName}
                            height='100%'
                            width='100%'
                          />
                        </Box>
                      </Grid>
                      <Grid item md={6} width={'100%'}>
                        <Box>
                          <Typography variant='h5' gutterBottom sx={{ overflowWrap: 'anywhere' }}>
                            {user.firstName} {user.lastName}
                          </Typography>
                          <Typography variant='body1' gutterBottom sx={{ overflowWrap: 'anywhere' }}>
                            {user.email} <br />
                            ID # {user.idNumber ? user.idNumber : user.id} <br />
                            User Role: {user.type}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignContent: 'flex-start',
                        justifyContent: 'end',
                      }}>
                      <Button
                        color='secondary'
                        variant='contained'
                        sx={{ marginRight: 2 }}
                        onClick={() => navigate('edit')}>
                        <EditIcon />
                      </Button>
                      <Button color='secondary' variant='contained' >
                        <DeleteIcon />
                      </Button>
                    </Box>
                  </CardContent>
                </StyledCard>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Box sx={{ height: 500, marginTop: 2 }}>
                <Typography variant='h5' gutterBottom>
                  Timesheets
                </Typography>
                <ListTimesheets
                  queryKey='workerTimesheets'
                  id={id}
                  navigate={navigate}
                  ts={ts}
                  getQuery={useGetTimeSheets}
                  updateQuery={useMutateUpdateTimeSheetForWorker}
                  showActionMenu={false}
                  customToolBarConfig={customToolBarConfig}
                  setIsExport={setIsExport}
                  selectedTab={selectedTab}
                />
              </Box>
            </Grid>
          </Container>
        </Box>
      ) : null}
    </>
  )
}
